<template>
  <div class="view-gabarit">
    <h2 class="head-box-title flat">{{ $t('modal.exportLoading') }}</h2>
    <div class="subtitle">{{ $t('modal.exportLoadingTime') }}</div>
  </div>
</template>

<script>
export default {
  props: ['params'],

  methods: {
    deleteStudy() {
      const { id } = this.params;
      this.$emit('closeModal');
      this.$store.dispatch('deleteStudy', { id }).then(() => {
        this.$store.dispatch('fetchStudies');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.view-gabarit {
  width: 680px;

  .subtitle {
    width: 100%;
    color: #77797f;
    font-size: 16px;
    text-align: center;
    margin: 12px 0 24px;
  }
}
</style>
